import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import React from "react";
import ButtonBar from "../../components/Buttons/ButtonBar";
import NewButton from "../../components/Buttons/NewButton";
import { Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import BasicMenu from "../../components/menu/BasicMenu";
import strings from "../../config/localization";
import { useGetResourceTemplatesQuery } from "../../services/appln";
import { doesPermissionExist } from "../util";
import DeleteResourceTemplate from "./DeleteResourceTemplate";
import EditResourceTemplate from "./EditResourceTemplate";
import NewResourceTemplate from "./NewResourceTemplate";

interface ResourceTemplate {
  id: string;
  name: string;
  assessments: any;
}

export default function ListResourceTemplates() {
  const resourceTemplatesQueryResponse = useGetResourceTemplatesQuery();

  const [newDialogOpen, setNewDialogOpen] = React.useState(false);

  const columns: ColumnsType<ResourceTemplate> = [
    {
      title: strings.name,
      dataIndex: "name",
      key: "name",
    },
    {
      title: strings.organization,
      dataIndex: "organizationName",
      key: "organizationName",
    },
    {
      title: strings.assessments,
      dataIndex: "assessments",
      key: "assessments",
      render: (text, record, index) => (
        <>
          {record.assessments
            .toSorted((x: any, y: any) => {
              return x.resourceTypeName.localeCompare(y.resourceTypeName);
            })
            .map((e: any) => {
              return `${e.resourceTypeName}:${e.count}`;
            })
            .join(", ")}
        </>
      ),
    },
  ];

  if (
    doesPermissionExist("delete-resource-assessment-template") ||
    doesPermissionExist("update-resource-assessment-template")
  ) {
    columns.push({
      title: "",
      dataIndex: "menu",
      key: "menu",
      render: (text, record, index) => {
        const options = [
          [
            null,
            <Stack direction={"column"} spacing={1}>
              {doesPermissionExist("update-resource-assessment-template") && (
                <EditResourceTemplate id={record.id!} initialValues={record} />
              )}
              {doesPermissionExist("delete-resource-assessment-template") && (
                <DeleteResourceTemplate id={record.id!} />
              )}
            </Stack>,
            null,
            "designations",
            "action",
          ],
        ];
        return (
          <BasicMenu
            action={strings.actions}
            options={options}
            data={record}
            type="location"
          />
        );
      },
    });
  }

  console.log(
    "ResourceTemplateList, resourceTemplatesQueryResponse:",
    resourceTemplatesQueryResponse,
  );

  return (
    <Box sx={{ width: "100%" }}>
      {(resourceTemplatesQueryResponse.isLoading ||
        resourceTemplatesQueryResponse.isFetching) && <ProgressIndicator />}
      <Stack spacing={2} style={{ alignItems: "flex-start" }}>
        <Title text={strings.resourceTemplates}></Title>
        <ButtonBar>
          <NewButton
            onClickHandler={() => {
              setNewDialogOpen(true);
            }}
          />
          <NewResourceTemplate
            onSubmitHandler={(newObj: any) => {
              setNewDialogOpen(false);
            }}
            onCancelHandler={() => {
              setNewDialogOpen(false);
            }}
            state={newDialogOpen}
          />
        </ButtonBar>
        <Table
          virtual
          scroll={{ y: 600 }}
          columns={columns}
          dataSource={resourceTemplatesQueryResponse.data?.data}
          pagination={false}
          rowKey="id"
        />
      </Stack>
    </Box>
  );
}
